import { Divider, Tooltip } from 'antd'
import Button from 'components/Button/index'
import CloseFilter from 'components/icons/CloseFilter'
import SearchInput from 'components/SearchInputReport'
import { Wrapper } from 'components/TableStyles/TableContentStyles/TableContentStyles'
import ReportSearchFilter from 'components/UIComponents/ReportSearchFilter'
import {
  Container,
  Content,
  FilterTextNew,
  Footer,
  MarginLeft,
} from 'components/UIComponents/ReportSearchFilter/Style/style'
import { arrayIntoString } from 'modules/Reports/Components/CommonFunction/CommonFunctionIndex'
import React, { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import { setStudentPlacedList } from '../../../actions'
import CityFilter from '../../Filter/SingleFilter'
import DegreeAndDepartmentFilter from '../../Filter/TreeFilter'
const ListOfStudentPlacedFilter = ({
  searchValue,
  setSearchValue,
  pageNum,
  tableData,
  degreeList,
  setDegreeValue,
  courseValue,
  setCourseValue,
  collegeValue,
  setCollegeValue,
  specialisationValue,
  setSpecialisationValue,
  setFilterData,
  nameValue,
  keyName,
  setNameValue,
  setKeyName,
  tooltip,
  universityData,
  UniversityUrl,
  universityLoader,
  setUniversityLoader,
  collegeData,
  CollegeUrl,
  collegeLoader,
  setCollegeLoader,
  degreeLoader,
  setDegreeList,
  degreeListData,
  searchQuery,
  setSearchDegree,
  corporateData,
  CorporateUrl,
  setCorporateLoader,
  corporateLoader,
  setSearchQuery,
  page,
  count,
  loadMoreData,
  loadingDep,
}) => {
  const dispatch = useDispatch()
  const [open, setOpen] = useState(true)
  const [clearFlag, setClearFlag] = useState(false)
  const [isMenuOpen, setIsMenuOpen] = useState(false)
  const [college, setCollege] = useState('')
  const [filterCancel, setFilterCancel] = useState(false)
  const [location, setLocation] = useState('')
  const onDegreeFilterChange = data => {
    setDegreeList(data)
  }
  const submitFilter = () => {
    setIsMenuOpen(false)
    let college = arrayIntoString(collegeValue)
    let course = arrayIntoString(courseValue)
    let specialisation = arrayIntoString(specialisationValue)
    let degree = arrayIntoString(degreeList)
    let corporate = arrayIntoString(nameValue)
    setIsMenuOpen(false)
    setFilterData({
      college: college,
      course: course,
      specialisation: specialisation,
      degree: degree,
      corporate: corporate,
    })
  }

  const onCancelFilter = open => {
    setClearFlag(true)
    setIsMenuOpen(!isMenuOpen)
    setCollegeValue([])
    setDegreeValue([])
    setCourseValue([])
    setSpecialisationValue([])
    setFilterData({})
    dispatch(setStudentPlacedList([]))
    setSearchQuery('')
    setLocation('')
    setCollege('')
    setSearchValue('')
    setDegreeList([])
    setKeyName('')
    setNameValue([])
    setSearchDegree([])
    setFilterCancel(true)
  }
  useEffect(() => {
    dispatch(setStudentPlacedList([]))
  }, [])

  return (
    <Wrapper>
      <ReportSearchFilter
        setOpen={setOpen}
        open={open}
        searchValue={searchValue}
        setSearchValue={setSearchValue}
        isReport={true}
        totalCount={tableData?.count}
        currentCount={10 * (pageNum - 1) + tableData?.result?.length}
      />
      <Divider style={{ margin: '0' }} />
      <Content isOpen={open}>
        <div style={{ width: '100%', display: 'flex', height: '18rem' }}>
          <Wrapper style={{ marginLeft: '1rem' }}>
            <FilterTextNew>{'Degree & Department'}</FilterTextNew>
            <SearchInput
              clearFlag={clearFlag}
              setClearFlag={setClearFlag}
              width={'90%'}
              placeholder="Search by keyword"
              bordered={true}
              searchValue={searchQuery}
              setSearchValue={value => {
                setSearchQuery(value)
              }}
            />
            <Container>
              <DegreeAndDepartmentFilter
                degreeList={degreeListData}
                setDegreeList={onDegreeFilterChange}
                searchQuery={searchQuery}
                degree={degreeList}
                setSearchDegree={setSearchDegree}
                loading={degreeLoader}
                filterCancel={filterCancel}
                setFilterCancel={setFilterCancel}
                degreeLoader={loadingDep}
                page={page}
                count={count}
                loadMoreData={loadMoreData}
              />
            </Container>
          </Wrapper>
          <Divider
            type="vertical"
            style={{
              height: '100%',
              width: '2px',
              borderTop: '18rem solid #e8e8e8',
            }}
          />
          <Wrapper>
            <FilterTextNew>{'Specialisation'}</FilterTextNew>
            <SearchInput
              clearFlag={clearFlag}
              setClearFlag={setClearFlag}
              width={'90%'}
              placeholder="Search by keyword"
              bordered={true}
              searchValue={location}
              setSearchValue={value => {
                setLocation(value)
              }}
            />
            <Container>
              <CityFilter
                key="3"
                value={specialisationValue}
                setValue={setSpecialisationValue}
                search={location}
                setSearch={setLocation}
                cityData={universityData}
                cityDetails={UniversityUrl}
                setLoading={setUniversityLoader}
                loading={universityLoader}
                valueParam={'specialisation'}
                labelParam={'specialisation'}
                flag={'LSP'}
              />
            </Container>
          </Wrapper>
          <Divider
            type="vertical"
            style={{
              height: '100%',
              width: '2px',
              borderTop: '18rem solid #e8e8e8',
            }}
          />

          <Wrapper>
            <FilterTextNew>{'College Name'}</FilterTextNew>
            <SearchInput
              clearFlag={clearFlag}
              setClearFlag={setClearFlag}
              width={'90%'}
              placeholder="Search by keyword"
              bordered={true}
              searchValue={college}
              setSearchValue={value => {
                setCollege(value)
              }}
            />
            <Container>
              <CityFilter
                key="4"
                search={college}
                setSearch={setCollege}
                value={collegeValue}
                setValue={setCollegeValue}
                cityData={collegeData}
                cityDetails={CollegeUrl}
                setLoading={setCollegeLoader}
                loading={collegeLoader}
                valueParam={'id'}
                labelParam={'campus_name'}
                flag={'LSP'}
              />
            </Container>
          </Wrapper>
          <Divider
            type="vertical"
            style={{
              height: '100%',
              width: '2px',
              borderTop: '18rem solid #e8e8e8',
            }}
          />
          <Wrapper>
            <FilterTextNew>{'Corporates'}</FilterTextNew>
            <SearchInput
              clearFlag={clearFlag}
              setClearFlag={setClearFlag}
              width={'90%'}
              placeholder="Search by keyword"
              bordered={true}
              searchValue={keyName}
              setSearchValue={value => {
                setKeyName(value)
              }}
            />
            <Container>
              <CityFilter
                key="5"
                search={keyName}
                setSearch={setKeyName}
                value={nameValue}
                setValue={setNameValue}
                cityData={corporateData}
                cityDetails={CorporateUrl}
                setLoading={setCorporateLoader}
                loading={corporateLoader}
                valueParam={'id'}
                labelParam={'name'}
                flag={'LSP'}
              />
            </Container>
          </Wrapper>

          <Divider
            type="vertical"
            style={{
              height: '100%',
              width: '2px',
              borderTop: '18rem solid #e8e8e8',
            }}
          />
        </div>
      </Content>
      <Divider style={{ margin: '0' }} />
      <Footer style={{ display: open ? '' : 'none' }}>
        <div
          style={{ marginRight: '180px' }}
          role="button"
          tabIndex="0"
          onClick={() => {
            setOpen(false)
          }}
          onKeyDown={() => {}}
        >
          <CloseFilter style={{ marginBottom: '-20px', cursor: 'pointer' }} />
        </div>
        <div style={{ marginRight: '30px' }}>
          <Button.Secondary
            height="35px"
            htmlType="Clear"
            text={'Clear Filter'}
            width={'144px'}
            onClick={() => onCancelFilter()}
          />
        </div>
        <div style={{ marginRight: '10px' }}>
          <MarginLeft>
            <Tooltip
              placement="topLeft"
              title={
                !tooltip
                  ? 'Kindly Select Filter Option Before Submitting the Data'
                  : ''
              }
            >
              <Button.Primary
                height="35px"
                htmlType="Save Filter"
                text={'Apply'}
                width={'144px'}
                onClick={() => submitFilter()}
              />
            </Tooltip>
          </MarginLeft>
        </div>
      </Footer>
      <Divider style={{ margin: '0' }} />
    </Wrapper>
  )
}

export default ListOfStudentPlacedFilter
